import moment from 'moment';

import { Api } from 'src/models/Api.model';
import { EntityCriteriaOperatorEnum } from 'src/models/GalenData/EntityCriteria.model';
import { IGetUsersRequestBody } from 'src/models/GalenData/Request.model';
import {
  GalenDataUser,
  GalenDataUserColumn,
} from 'src/models/GalenData/User.model';

export interface PatientMatchData {
  id?: string;
  dob?: string;
  firstName?: string;
  lastName?: string;
}

export const getMatchedPatient = async (
  data: PatientMatchData,
): Promise<GalenDataUser[]> => {
  const filterConditions: {
    key: keyof (GalenDataUserColumn & IGetUsersRequestBody);
    value: string | undefined;
  }[] = [
    { key: 'patientId', value: data.id?.trim() },
    {
      key: 'dateOfBirth',
      value: data.dob ? moment(data.dob).format('YYYY-MM-DD') : undefined,
    },
    { key: 'firstName', value: data.firstName?.trim() },
    { key: 'lastName', value: data.lastName?.trim() },
  ];

  const filters = filterConditions
    .filter(({ value }) => value)
    .map(({ key, value }) => ({
      key,
      value,
      operator: EntityCriteriaOperatorEnum.Equal,
    }));

  const response = await Api.remote._get_users_advanced(filters);

  return response.data.content || [];
};
